import {
  getData,
  getOrganizations,
  getJuridicalForms,
  associateDashboard,
  getAssociationDashboard,
  getCollaborators,
  getFinancialFiche,
  requestSynchro
} from "Api";
import * as actions from "Actions";

export const setData = data => {
  return (dispatch, getState) => {
    const { financialProfile } = getState();
    const { uen } = financialProfile;
    dispatch(
      actions.fetchData(
        getData({ uen: uen }).then(res => {
          const data = res.data.data;
          return data;
        })
      )
    );
  };
};

export const fetchOrganizations = (synchro = false) => {
  return (dispatch, getState) => {
    const { paginationPage, pageSize } = getState().organizations.list;
    const {
      name,
      type,
      juridicalForms,
      collaborators,
      roleCollaborator,
      clientCRMTypes,
      clientCRMGroup,
      sortMetrics,
      configState,
      year,
      presentationState,
      synchroState,
      importedBalance
    } = getState().organizations.list.filter;
    const { uid } = getState().auth.user;
    const { spaceAs, currentOrganization } = getState().auth;
    let data = {
      paginationPage,
      pageSize,
      name,
      type,
      juridicalForms,
      collaborators,
      roleCollaborator,
      clientCRMTypes,
      clientCRMGroup,
      sortMetrics,
      configState,
      year,
      presentationState,
      synchroState,
      uid,
      currentOrganization,
      spaceAs,
      synchro,
      importedBalance
    };

    dispatch(
      actions.fetchOrganizations(
        getOrganizations(data).then(res => {
          const data = res.data.data;
          return data;
        })
      )
    );
  };
};

export const fetchFicheClient = (organizationUen, synchro = false, year) => {
  return (dispatch, getState) => {
    dispatch(
      actions.fetchOrganizations(
        getFinancialFiche(organizationUen, year).then(res => {
          let data = res.data;

          // Just a hack to resolve quickly the fetching of Fiche client
          data.data = [data.data];
          data.nbResult = 1;

          return data;
        })
      )
    );
  };
};

export const fetchCollaboratorsSuggestions = searchWord => {
  return (dispatch, getState) => {
    const { uen } = getState().auth.currentOrganization;
    let noLimit = true;
    let data = { uen, searchWord, noLimit };
    return dispatch(actions.fetchCollaborators(getCollaborators(data)));
  };
};

export const fetchOrganisationsJuridicalFormSuggestions = ({
  searchWord,
  lng
}) => {
  return (dispatch, getState) => {
    return dispatch(
      actions.setOrganizationJuridicalFormSuggestions(
        getJuridicalForms({ searchWord, lng })
      )
    );
  };
};

export const fetchAssociationDashboard = () => {
  return (dispatch, getState) => {
    const {
      auth: { currentOrganization },
      organizations: { list }
    } = getState();

    const { uen } = currentOrganization;
    const { selected } = list;
    dispatch(
      actions.fetchAssociationDashboard(
        getAssociationDashboard({
          uen: uen,
          clients: selected
        }).then(res => {
          const data = res.data.data;
          return data;
        })
      )
    );
  };
};

export const saveAssociationDashboard = ({ dashboardId }) => {
  return (dispatch, getState) => {
    const { selected } = getState().organizations.list;

    return dispatch(
      actions.saveAssociationDashboard(
        associateDashboard({
          dashboardId,
          selected
        })
      )
    );
  };
};

export const setRequestSynchro = uen => {
  return (dispatch, getState) => {
    return dispatch(
      actions.requestSynchro(
        requestSynchro({
          organizationUen: uen,
          status: 1
        }).then(res => res.data)
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/data.js